class StorageHandler {
    constructor() {
        if (StorageHandler.instance) return StorageHandler.instance;

        this.storageKey = 'filterItems';

        document.addEventListener('dropdownInputChange', (event) => {
            this.handleDataChange(event.detail);
        });

        StorageHandler.instance = this;
    }

    fetchData() {
        return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    }

    storeData(items) {
        localStorage.setItem(this.storageKey, JSON.stringify(items));
    }

    clearData() {
        localStorage.removeItem(this.storageKey);
    }

    handleDataChange(item) {
        let items = this.fetchData();
        const slugOrder = ['region', 'audience', 'feature'];

        if (item.checked) {
            const exists = items.some(i => i.value === item.value && i.slug === item.slug);
            if (!exists) {
                items.push(item);
            }
        } else {
            items = items.filter(i => !(i.value === item.value && i.slug === item.slug));
        }

        items.sort((a, b) => slugOrder.indexOf(a.slug) - slugOrder.indexOf(b.slug));

        this.storeData(items);

        const event = new CustomEvent('filterDataChanged', {
            bubbles: true
        });

        document.dispatchEvent(event);
    }
}

export default StorageHandler;
